import { z } from 'zod'

// base_filters は汎用スキーマだが既存の millsheet 配下にあるため、重複定義を避けて再利用する
import {
  dateTimeFilterSchema,
  numberFilterSchema,
  stringFilterSchema,
  stringInFilterSchema,
} from '../millsheet/base_filters'

// 親（剪断証明書）レベルのフィルタ + item（明細）レベルのフィルタ（item* prefix）
export const shearingCertificatesFilterSchema = z.object({
  issuingCompanyName: stringInFilterSchema.optional(),
  issuedDate: dateTimeFilterSchema.optional(),
  certificateNo: stringFilterSchema.optional(),
  constructionName: stringInFilterSchema.optional(),
  // 明細（個体番号単位）レベル
  itemSteelType: stringInFilterSchema.optional(),
  itemThickness: stringFilterSchema.optional(),
  itemNo: stringFilterSchema.optional(),
  itemIndividualNumber: stringFilterSchema.optional(),
  itemManufacturerName: stringInFilterSchema.optional(),
  itemWeight: numberFilterSchema.optional(),
})
export type ShearingCertificatesFilter = z.infer<typeof shearingCertificatesFilterSchema>

const sorterDirectionSchema = z.enum(['asc', 'desc'])
export const shearingCertificatesSorterSchema = z.union([
  z.object({ issuingCompanyName: sorterDirectionSchema }),
  z.object({ issuedDate: sorterDirectionSchema }),
  z.object({ certificateNo: sorterDirectionSchema }),
  z.object({ constructionName: sorterDirectionSchema }),
])
export type ShearingCertificatesSorter = z.infer<typeof shearingCertificatesSorterSchema>

export const shearingCertificateSearchConditionSchema = z.object({
  filter: shearingCertificatesFilterSchema.optional(),
  sorter: shearingCertificatesSorterSchema.array().optional(),
  limit: z.number().optional(),
  offset: z.number().optional(),
})
export type ShearingCertificateSearchCondition = z.infer<typeof shearingCertificateSearchConditionSchema>
